module.exports = __webpack_public_path__ + "img/hotel.112dd6fe.png";